import { ProviderColorTheme } from '../common/SocialButtonsOptions/constants';
import {
  getThemeStyles,
  ThemeConfig,
} from '../common/SocialButtonsSection/providerThemeStyles';

/** Convert a hex color like '#FFFFFF' to an RGB string '255, 255, 255'. */
export const hexToRgb = (hex: string): string => {
  const h = hex.replace('#', '');
  return `${parseInt(h.slice(0, 2), 16)}, ${parseInt(
    h.slice(2, 4),
    16,
  )}, ${parseInt(h.slice(4, 6), 16)}`;
};

/**
 * Get the default RGB string for a provider color style property.
 * Used in customCssVars so that provider color defaults are always emitted as
 * CSS vars — the TPA platform doesn't emit CSS vars for color params with
 * `name: null` in Studio viewer.
 */
export const getProviderColorDefault = (
  theme: ProviderColorTheme,
  providerId: string,
  property: keyof ThemeConfig['styles'],
): string => {
  const style = getThemeStyles(theme, providerId, property);
  if (style && typeof style === 'object' && 'value' in style) {
    return hexToRgb(style.value);
  }
  return '0, 0, 0';
};
